export default {
    set_list(state, list){
        state.list = list.data
    }
}